const WhyItMatters = () => {
  const benefits = [
    {
      id: 1,
      // icon: '/assets/aida/time.svg',
      title: 'Saves Time',
      description: 'Automates document handling and speeds up workflows.'
    },
    {
      id: 2,
      // icon: '/assets/aida/check.svg',
      title: 'Accuracy & Consistency',
      description: 'Reduces human errors, ensuring reliable results.'
    },
    {
      id: 3,
      // icon: '/assets/aida/dollar.svg',
      title: 'Cost Efficiency',
      description: 'Optimizes resources by handling repetitive tasks automatically.'
    }
  ];

  return (
    <section className="py-10 md:py-28 lg:pt-32 xl:pt-32 light-blue-bg">
      <div className="container mx-auto px-4 md:px-8 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12 lg:mb-14">
          <h2 className="font-bold mb-4 md:mb-5">
            <span className="">Why it </span>
            <span className="secondary-text">Matters?</span>
          </h2>
          <p className="     max-w-4xl mx-auto px-4 leading-relaxed">
            Organizations spend countless hours handling documents manually — slowing down processes, increasing errors, 
            and driving up costs. In a data-driven world, this inefficiency holds businesses back.
          </p>
        </div>

        {/* Benefits Card */}
        <div className="primary-bg rounded-xl py-6 md:py-10 lg:py-12 px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 lg:gap-14 max-w-5xl mx-auto">
            {benefits.map((benefit, index) => (
              <div
                key={benefit.id}
                className="text-center group relative"
              >
                {/* Vertical Divider */}
                {index < benefits.length - 1 && (
                  <div className="hidden md:block absolute -right-5 lg:-right-7 top-1/2 -translate-y-1/2 h-32 lg:h-36 w-px bg-white opacity-20" />
                )}

                {/* Icon */}
                {/* <div className="flex justify-center mb-5 md:mb-6">
                  <div className="w-6 h-6 md:w-10 md:h-10 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                    <img 
                      src={benefit.icon} 
                      alt={benefit.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div> */}

                {/* Content */}
                <div>
                  <h3 className="text-white    font-bold">
                    {benefit.title}
                  </h3>
                  <p className="text-white   opacity-90 leading-relaxed px-2">
                    {benefit.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyItMatters;